import React from 'react';
import { Card, Switch, Badge, Tooltip, Button } from 'antd';
import { CrownOutlined, RobotOutlined, AlertOutlined, BulbOutlined, BarChartOutlined } from '@ant-design/icons';
import { useFeatures } from '../context/FeatureContext';

const PremiumFeatures: React.FC = () => {
  const { features, isPremium, toggleFeature } = useFeatures();

  const featureList = [
    {
      key: 'aiPrediction' as const,
      title: 'Previsão de Custos com IA',
      description: 'Previsão de custos para 6-12 meses usando Prophet (Facebook)',
      icon: <RobotOutlined />,
      color: '#1890ff'
    },
    {
      key: 'anomalyDetection' as const,
      title: 'Detecção de Anomalias',
      description: 'Identificação automática de picos e quedas anômalas nos custos',
      icon: <AlertOutlined />,
      color: '#ff4d4f'
    },
    {
      key: 'intelligentRightsizing' as const,
      title: 'Rightsizing Inteligente',
      description: 'Recomendações de dimensionamento baseadas em ML e padrões de uso',
      icon: <BulbOutlined />,
      color: '#52c41a'
    },
    {
      key: 'advancedAnalytics' as const,
      title: 'Analytics Avançado',
      description: 'Insights profundos com correlações e análises preditivas',
      icon: <BarChartOutlined />,
      color: '#722ed1'
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
        <CrownOutlined style={{ fontSize: '24px', color: '#faad14', marginRight: '12px' }} />
        <h2 style={{ margin: 0, fontSize: '20px' }}>Recursos Premium</h2>
        {isPremium && (
          <Badge 
            count="PRO" 
            style={{ backgroundColor: '#faad14', marginLeft: '12px' }} 
          />
        )}
      </div>

      {!isPremium && (
        <Card style={{ marginBottom: '24px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
          <div style={{ textAlign: 'center' }}>
            <CrownOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
            <h3 style={{ color: 'white', marginBottom: '8px' }}>Desbloqueie o Poder da IA</h3>
            <p style={{ color: 'rgba(255,255,255,0.8)', marginBottom: '16px' }}>
              Otimize seus custos com inteligência artificial avançada
            </p>
            <Button 
              type="primary" 
              size="large" 
              style={{ background: '#faad14', borderColor: '#faad14' }}
              onClick={() => {
                localStorage.setItem('userPlan', 'premium');
                window.location.reload();
              }}
            >
              Fazer Upgrade para Premium
            </Button>
          </div>
        </Card>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px' }}>
        {featureList.map((feature) => (
          <Card key={feature.key} size="small">
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <div 
                style={{ 
                  color: feature.color, 
                  fontSize: '24px',
                  marginTop: '4px'
                }}
              >
                {feature.icon}
              </div>
              
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 600 }}>
                    {feature.title}
                  </h4>
                  
                  <Tooltip title={!isPremium ? "Upgrade para Premium necessário" : "Ativar/Desativar recurso"}>
                    <Switch
                      size="small"
                      checked={features[feature.key]}
                      onChange={() => toggleFeature(feature.key)}
                      disabled={!isPremium}
                    />
                  </Tooltip>
                </div>
                
                <p style={{ 
                  margin: 0, 
                  fontSize: '12px', 
                  color: '#666',
                  lineHeight: '1.4'
                }}>
                  {feature.description}
                </p>
                
                {!isPremium && (
                  <Badge 
                    count="Premium" 
                    style={{ 
                      backgroundColor: '#faad14', 
                      fontSize: '10px',
                      marginTop: '8px'
                    }} 
                  />
                )}
              </div>
            </div>
          </Card>
        ))}
      </div>

      {isPremium && (
        <Card style={{ marginTop: '24px', borderColor: '#52c41a' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ color: '#52c41a', fontSize: '20px' }}>
              ✓
            </div>
            <div>
              <h4 style={{ margin: 0, color: '#52c41a' }}>Plano Premium Ativo</h4>
              <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                Você tem acesso a todos os recursos de IA e analytics avançados
              </p>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default PremiumFeatures;